import type { ReactNode } from "react";

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, description, actions }: PageHeaderProps) {
  return (
    <header className="mb-[27px] flex flex-wrap items-end justify-between gap-5">
      <div>
        {eyebrow ? (
          <p className="mb-[10px] text-xs font-semibold tracking-[0.07em] text-[#7d8793] uppercase">
            {eyebrow}
          </p>
        ) : null}
        <h1 className="text-[32px] leading-[1.15] font-[650] tracking-[-1.2px] text-edlab-ink">
          {title}
        </h1>
        {description ? (
          <p className="mt-[9px] max-w-2xl text-sm leading-relaxed text-edlab-muted">
            {description}
          </p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-[10px]">{actions}</div>
      ) : null}
    </header>
  );
}
